<template>
  <div class="notif-right">
    <div class="notif-title">{{$t('Home.sysMsg')}}</div>
    <!--  -->
    <v-virtual-scroll
      height="432"
      :bench="benched"
        :items="items"
      item-height="72"
  >
  <template v-slot:default="{ item }">
  <div :key="item" class="notif-content">
      <span>{{$t('Home.newMsg')}}</span>
      <span>2分钟前</span>
    </div>
  </template>
</v-virtual-scroll>
  <v-img
  lazy-src="@/assets/images/home/home_noti.png"
  src="@/assets/images/home/home_noti.png"
  height="305"
  width="307"
   />
  </div>
</template>

<script>
export default {
  data() {
    return {
      benched: 0,
      items: [1, 2, 3, 4, 5, 6, 7, 8, 9],
    };
  },
};
</script>
<style lang="scss" scoped>
  .notif-right {
    padding: 0 13px;
    .notif-title {
      width: 100%;
      padding: 17px 5px;
      font-family: PingFangSC-Semibold;
      font-size: 16px;
      color: #131523;
      letter-spacing: 0;
      border-bottom: 1px solid #D7DBEC;
    }
    .notif-content {
      padding: 22px 10px;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #D7DBEC;
      padding-left: 15px;
      :first-child {
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #131523;
      }
      :last-child {
        font-family: PingFangSC-Light;
        font-size: 10px;
        color: #003600;
      }
    }
  }
</style>
